"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A type-safe wrapper for Array.prototype.push.apply()
 * @param mainArray The main array to push items into
 * @param itemsArray The items to push to main array
 */
function arrayPush(mainArray, itemsArray) {
    Array.prototype.push.apply(mainArray, itemsArray);
}
exports.default = arrayPush;
//# sourceMappingURL=arrayPush.js.map